// extracted by mini-css-extract-plugin
module.exports = {"StockInsidersPage":"insiders_StockInsidersPage__UnshJ"};